import React from 'react'
import WriteReviewForm from './WriteReviewForm'
import useWriteReview from './hooks/useWriteReview'

import * as Styled from './WriteReview.styles'

const WriteReview = ({ productName, images, onSubmit }) => {
  const {
    formData,
    setInput,
    setCheckbox,
    validateInput,
    onRatingChange,
    onAddPhoto,
    onRemovePhotoClick
  } = useWriteReview()

  return (
    <>
      <Styled.Heading>Write a review</Styled.Heading>
      <Styled.Content>
        <Styled.ProductContainer>
          <Styled.ProductTitle>{productName}</Styled.ProductTitle>
          <Styled.ImageWrapper>
            <Styled.Image src={images[0]} alt={productName} width='367' quality='70' lazy />
          </Styled.ImageWrapper>
        </Styled.ProductContainer>
        <Styled.FormContainer>
          <WriteReviewForm
            {...{
              formData,
              setInput,
              setCheckbox,
              validateInput,
              onRatingChange,
              onAddPhoto,
              onRemovePhotoClick,
              onSubmit
            }}
          />
        </Styled.FormContainer>
      </Styled.Content>
    </>
  )
}

export default WriteReview
